import { render, staticRenderFns } from "./kegiatanbmtk.vue?vue&type=template&id=168b1246"
import script from "./kegiatanbmtk.vue?vue&type=script&lang=js"
export * from "./kegiatanbmtk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports